import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Select, Row, Col, Tabs } from 'antd';

const { TabPane } = Tabs;

const Settings = (props) => {
  //const [formLayout, setFormLayout] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache, translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const renderWidget = (columns) => {
    let { widget, label, options, value } = columns;
    switch (widget) {
      case 'select':
        return (
          <Form.Item label={translation(label)}>
            <Select style={{ width: 220 }}>
              {options &&
                Array.isArray(options) &&
                options.map((value) => (
                  <Select.Option key={value} value={value}>
                    {value}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        );
      default:
        return (
          <Form.Item label={translation(label)}>
            <div>{value}</div>
          </Form.Item>
        );
    }
  };

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4
    }
  };

  let columns1 = [
    {
      label: translation('HD'),
      widget: 'select',
      options: ['01']
    },
    {
      label: translation('CH'),
      widget: 'select',
      options: ['01']
    },
    {
      label: translation('Hold'),
      widget: 'select',
      options: ['None']
    },
    {
      label: translation('PGC Mode'),
      widget: 'select',
      options: ['Auto', 'Fixed']
    },
    {
      label: translation('Display Moisture'),
      widget: 'text',
      value: '21.3'
    },
    {
      label: translation('Raw Moisture'),
      value: '211.3'
    },
    {
      label: translation('Absorbance (X1)'),
      widget: 'text',
      value: '21.3'
    },
    {
      label: translation('Absorbance (X2)'),
      widget: 'text',
      value: '21.3'
    }
  ];
  let columns2 = [
    {
      label: translation('Alarm'),
      widget: 'text',
      value: 'None'
    },
    {
      label: translation('Hold'),
      widget: 'text',
      value: 'None'
    },
    {
      label: translation('PGC Mode'),
      widget: 'text',
      value: 'Auto'
    },
    {
      label: translation('Temperature(t)'),
      widget: 'text',
      value: '27.3'
    },
    {
      label: translation('Temperature Volt(vt)'),
      widget: 'text',
      value: '0.245'
    },
    {
      label: translation('Volt(v1)'),
      widget: 'text',
      value: '1.6589'
    },
    {
      label: translation('Volt(v2)'),
      widget: 'text',
      value: '1.6229'
    },
    {
      label: translation('Volt(v3)'),
      widget: 'text',
      value: '1.6589'
    },
    {
      label: translation('PGC'),
      widget: 'text',
      value: '40.0'
    }
  ];
  let columns3 = [
    {
      label: translation('E-01'),
      widget: 'text',
      value: 'Ro level error'
    },
    {
      label: translation('E-02'),
      widget: 'text',
      value: 'Temperature error- high'
    },
    {
      label: translation('E-03'),
      widget: 'text',
      value: 'Temperature error- low'
    },
    {
      label: translation('E-04'),
      widget: 'text',
      value: 'Absorbance calculation error'
    },
    {
      label: translation('E-05'),
      widget: 'text',
      value: 'Motor error'
    }
  ];
  let columns4 = [
    {
      label: translation('E-07'),
      widget: 'text',
      value: 'Channel unset'
    },
    {
      label: translation('E-08'),
      widget: 'text',
      value: 'System memory error'
    },
    {
      label: translation('E-09'),
      widget: 'text',
      value: 'Channel memory error'
    },
    {
      label: translation('E-12'),
      widget: 'text',
      value: 'Sensor data input error'
    }
  ];

  return (
    <div style={{}}>
      <Tabs defaultActiveKey="1" type="card">
        <TabPane tab={translation('Communication Settings')} key={'CS'}>
          <div>
            <Form
              {...formItemLayout}
              layout="horizontal"
              name={translation('HeaderNumber_current')}
              style={{ margin: '19px', padding: '30px' }}
            >
              <label style={{  fontWeight: 'bolder' }}>
                {translation('Head Number Current')}
              </label>
              <Form.Item label={translation('HD')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="01">01</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item {...buttonItemLayout}>
                <Button type="primary">{translation('Check')}</Button>
              </Form.Item>
            </Form>
            <Form
              {...formItemLayout}
              layout="horizontal"
              name={translation('HeaderNumber_change')}
              style={{ margin: '19px', padding: '30px' }}
            >
              <label style={{  fontWeight: 'bolder' }}>
                {translation('Head Number Change')}
              </label>
              <Form.Item label={translation('HD')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="01">01</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item {...buttonItemLayout}>
                <Button type="primary">{translation('Settings')}</Button>
              </Form.Item>
            </Form>
            <Form
              {...formItemLayout}
              layout="horizontal"
              name={translation('COM_PORT')}
              style={{ margin: '19px', padding: '30px' }}
            >
              <label style={{  fontWeight: 'bolder' }}>
                {translation('COM Port')}
              </label>
              <Form.Item label={translation('Number')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="01">01</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label={translation('Baud rate')}>
                <div>9600</div>
              </Form.Item>
              <Form.Item label={translation('Data')}>
                <div>8</div>
              </Form.Item>
              <Form.Item label={translation('Parity')}>
                <div>None</div>
              </Form.Item>
              <Form.Item label={translation('Stop Bit')}>
                <div>1</div>
              </Form.Item>
              <Form.Item {...buttonItemLayout}>
                <Button type="primary">{translation('Com. Check')}</Button>
              </Form.Item>
            </Form>
          </div>
        </TabPane>
        <TabPane tab={translation('Status Check')} key={'SC'}>
          <div style={{}}>
            <Form
              {...formItemLayout}
              layout="horizontal"
              name="HeaderNumber_current"
              style={{ margin: '19px', padding: '30px' }}
            >
              <Row>
                <Col flex={3}>
                  {columns1 &&
                    columns1.map((columnData) => (
                      renderWidget(columnData)
                    ))}
                </Col>
                <Col flex={3}>
                  {columns2 &&
                    columns2.map((columnData) => (
                      renderWidget(columnData)
                    ))}
                </Col>
              </Row>
              <div style={{ border: '1px dashed' }}>
                <Row>
                  <Col flex={3}>
                    {columns3 &&
                      columns3.map((columnData) => (
                        renderWidget(columnData)
                      ))}
                  </Col>
                  <Col flex={3}>
                    {columns4 &&
                      columns4.map((columnData) => (
                        renderWidget(columnData)
                      ))}
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
        </TabPane>
        <TabPane tab={translation('Version Information')} key={'VI'}>
          <div style={{}}>
            <Form
              {...formItemLayout}
              layout="horizontal"
              name={translation('HeaderNumber_current')}
              style={{ margin: '19px', padding: '30px' }}
            >
              <label style={{  fontWeight: 'bolder' }}>
                {translation('Kb-30')}
              </label>
              <Form.Item label={translation('HD')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="01">01</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label={translation('Version')}>
                <Select style={{ width: 220 }}>
                  <div>008-V2.1</div>
                </Select>
              </Form.Item>
              <Form.Item label={translation('Update')}>
                <div>2022/05/25</div>
              </Form.Item>
            </Form>
            <Form
              {...formItemLayout}
              layout="horizontal"
              name={translation('KB-software')}
              style={{ margin: '19px', padding: '30px' }}
            >
              <label style={{  fontWeight: 'bolder' }}>
                {translation('Kb30 Pc Software')}
              </label>
              <Form.Item label={translation('Drawing No')}>
                <div>OVS2004E</div>
              </Form.Item>
              <Form.Item label={translation('Version')}>
                <Select style={{ width: 220 }}>
                  <div>1.1.1</div>
                </Select>
              </Form.Item>
              <Form.Item label={translation('Update')}>
                <div>2022/05/25 12:23:56</div>
              </Form.Item>
            </Form>
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Settings);
